import EditIcon from '@mui/icons-material/Edit';
import { Checkbox, Tooltip } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';

import RoundIconButton from '@/components/button/RoundIconButton';
import { dateUtils } from '@/utils/date';

export const columns = ({ reminderDialogRef }: any): GridColDef[] => [
    {
        field: 'name',
        headerName: 'Tên lịch',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
    },
    {
        field: 'installationDate',
        headerName: 'Ngày lắp đặt',
        editable: false,
        sortable: false,
        minWidth: 150,
        flex: 1,
        renderCell: (params: any) => {
            return <>{dateUtils.getDate(params.row.installationDate)}</>;
        },
    },
    {
        field: 'partDetail',
        headerName: 'Tên thành phần',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 200,
        renderCell: (params: any) => (
            <Tooltip title={params.row.partDetail?.name}>
                {params.row.partDetail?.name || '-:-'}
            </Tooltip>
        ),
    },
    {
        field: 'nextMaintenanceDate',
        headerName: 'Dự kiến bảo trì kế tiếp',
        editable: false,
        sortable: false,
        minWidth: 150,
        flex: 1,
        renderCell: (params: any) =>
            dateUtils.getDate(params.row.nextMaintenanceDate),
    },
    {
        field: 'isFilterHead',
        headerName: 'Thay lọc',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: (params: any) => {
            return <Checkbox disabled checked={params.row.isFilterHead} />;
        },
    },
    {
        field: 'action',
        headerName: 'Hành động',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 150,
        renderCell: ({ row }) => (
            <RoundIconButton
                icon={<EditIcon />}
                onClick={() => {
                    reminderDialogRef.current?.openWithData(row);
                }}
            />
        ),
    },
];
